/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sorting_StatsInputs */

const vi_nav_sorting_stats = /** @type {(inputs: Nav_Sorting_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê`)
};

/**

* @param {Nav_Sorting_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_sorting_stats = /** @type {((inputs?: Nav_Sorting_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sorting_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_sorting_stats(inputs)
});